module.exports = __webpack_public_path__ + "img/Huster2022.13393d35.jpg";